// src/pages/HomePage.js
import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import './HomePage.css'; 

const HomePage = () => {
  return (
    <div className="home-page">
      <PublicNavbar />
      <header className="home-hero">
        <div className="home-hero-content">
          <h1>Connecting Homeless Communities to Valuable Resources</h1>
          <p className="mission-statement">
            Salt Lake City and Phoenix
          </p>
        </div>
      </header>

      <main className="home-main-content">
        <section className="news-section">
          <h2>What does Inclusive Ai do?</h2>
          
          <div className="info-card">
            <div className="info-card-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fhome_rf.jpg?alt=media&token=060ff4c0-dddb-49b7-a23e-9b0c58b49751" alt="Resource Finder" />
            </div>
            <div className="info-card-text">
              <h3>Resource Finder</h3>
              <p>A curated list of all of the free resources available in the area. Sorted by category, the user can tell the app what they need and it will let them know how to access all of the free goods and services available. </p>
              <p className="news-link">
                <a href="https://myinclusiveai.org/about" target="_blank" rel="noopener noreferrer">
                  Click here to learn more.
                </a>
              </p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-card-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fhome_wd.jpg?alt=media&token=028f6240-ca4d-41c1-89ae-9aa08c9cead8" alt="Walking Directions" />
            </div>
            <div className="info-card-text">
              <h3>Walking Directions</h3>
              <p>When they find something they need, the app will guide them step by step using walking directions. If they need transportation, the app will help them with a travel voucher and direct them to a free ride (when available). </p>
              <p className="news-link">
                <a href="https://myinclusiveai.org/about" target="_blank" rel="noopener noreferrer">
                  Click here to learn more.
                </a>
              </p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-card-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fhome_jc.jpg?alt=media&token=cc90e8df-6452-450b-9a6f-ffd45481fb20" alt="Find Employment" />
            </div>
            <div className="info-card-text">
              <h3>Find Employment</h3>
              <p>After they have met their immediate needs, finding a new job is the most important next step for them. Our app includes valuable tools that will ensure success finding and securing good employment.  </p>
              <p className="news-link">
                <a href="https://myinclusiveai.org/about" target="_blank" rel="noopener noreferrer">
                  Click here to learn more.
                </a>
              </p>
            </div>
          </div>

        </section>

        <section className="cta-section">
          <h2>Help Us Make a Difference</h2>
          <p>Your contribution helps us reach more individuals.</p>
          <p>We appreciate your support.</p>
          <a href="/contact" className="cta-button">Donate or Get Involved</a>
        </section>
      </main>

      <footer className="home-footer">
        <p>&copy; 2025 Inclusive AI. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;